// src/components/register/RegistrationWizard/Steps/EducationalForms/PhdForm.js
import React, { useState, useEffect } from "react";
import SearchDropdown from "../../../../Usables/SearchDropdown";
import Dropdown from "../../../../Usables/Dropdown/Dropdown";
import MultiSelectDropdown from "../../../../Usables/MultiSelectDropdown";
import FloatInputField from "../../../../Usables/FloatInputField";
import CollegeList from "../../../../userForms/FormsData/Colleges";
import YearOfStudy from "../../../../userForms/FormsData/Year";
import FutureOpportunityTypesList from "../../../../userForms/FormsData/FutureFields";
import Specializations from "../../../../options/phdDegree";
import BachelorsExam from "../../../../userForms/Bachelors/BachelorsExam";

const PhdForm = ({ onChange, data = {} }) => {
  // Form state
  const [college, setCollege] = useState(data.collegename || "");
  const [collegeName, setCollegeName] = useState(data.collegename || "");
  const [year, setYear] = useState(data.collegeyear || "");
  const [yearRAG, setYearRAG] = useState("");
  const [specialization, setSpecialization] = useState(data.specialization || "");
  const [specializationRAG, setSpecializationRAG] = useState("");
  const [compensation, setCompensation] = useState(data.compensation || "");
  const [gpa, setGPA] = useState(data.gpa || "");
  const [futureOpportunityTypes, setFutureOpportunityTypes] = useState(
    data.futureOpportunityTypes ? JSON.parse(data.futureOpportunityTypes) : []
  );
  const [exams, setExams] = useState(data.exams ? JSON.parse(data.exams) : [
    {
      type: "text",
      id: 1,
      name: "",
      date: "",
      percentage: "",
      criteria: "100 %",
    },
  ]);

  // Update parent component whenever form data changes
  useEffect(() => {
    onChange({
      collegename: college,
      collegeyear: year,
      specialization,
      compensation,
      gpa,
      futureOpportunityTypes: JSON.stringify(getValuesArray(futureOpportunityTypes)),
      exams: JSON.stringify(exams)
    });
  }, [
    college, year, specialization, compensation, gpa, 
    futureOpportunityTypes, exams, onChange
  ]);

  // Helper function to extract values from multi-select options
  const getValuesArray = (options) => {
    if (!options || options.length === 0) return [];
    return options.map(option => option.value);
  };

  const handleCollege = (value, label) => {
    setCollegeName(label);
    setCollege(value);
  };

  const handleYear = (e) => {
    setYear(e.value);
    // e.value is a number in form of string, and our database has string only
    let ind = parseInt(e.value) - 1;
    setYearRAG(YearOfStudy[ind].label);
  };

  const handleSpecialization = (value, label) => {
    setSpecializationRAG(label);
    setSpecialization(value);
  };

  const handleCompensation = (event) => {
    setCompensation(event.target.value);
  };

  const handleGPA = (event) => {
    setGPA(event.target.value);
  };

  const handleFutureOppsTypes = (options) => {
    setFutureOpportunityTypes(options);
  };

  return (
    <div className="educational-form-content">
      <div className="form-section">
        <SearchDropdown
          options={CollegeList}
          onSelect={handleCollege}
          placeholderInput="Search your College"
          placeholderDropdown="College Name"
          value={{ value: college, label: collegeName }}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="currentYear"
          value={year}
          options={YearOfStudy}
          placeHolder="Current Year of Study"
          onChange={handleYear}
        />
      </div>
      
      <div className="form-section">
        <SearchDropdown
          options={Specializations}
          onSelect={handleSpecialization}
          placeholderInput="Search your specialization"
          placeholderDropdown="Specialization"
          value={{ value: specialization, label: specializationRAG }}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="expectedCompensation"
          placeHolder="Expected Compensation (INR Monthly)"
          handleInput={handleCompensation}
          inputVal={compensation}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="gpa"
          placeHolder="Current GPA (On a scale of 10)"
          handleInput={handleGPA}
          inputVal={gpa}
        />
      </div>
      
      <div className="form-section exams-section">
        <BachelorsExam exams={exams} setExams={setExams} />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={FutureOpportunityTypesList}
          onSelect={handleFutureOppsTypes}
          value={futureOpportunityTypes}
          placeholderDropdown="Opportunity types interested in"
          placeholderInput="Search for interested fields"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
    </div>
  );
};

export default PhdForm;